import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import OnlineSignals from '../views/onlineSignals.vue';
import Login from '../views/login.vue';
import NotFoundView from '../components/NotFound.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/online-signals',
    name: 'online-signals',
    component: OnlineSignals
  },
  {
    path: "/:pathMatch(.*)*", // این مسیر هر آدرسی که پیدا نشود را می‌گیرد
    component: NotFoundView, // کامپوننت صفحه 404
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // اگر کاربر دکمه برگشت را زده باشد، به موقعیت قبلی اسکرول می‌کند
    } else {
      return { left: 0, top: 0 }; // به ابتدای صفحه برو
    }
  }
})

export default router
